import omit from "lodash/omit";

export default function omitValidationAndDirtyCheck(entity: Record<string, any>) {
  return omit(entity, ["__validation", "__dirtycheck"]);
}
